module.exports = __webpack_public_path__ + "static/media/git--gud-B-yellowgreen.a86ab6e6.svg";